export const HOW_DID_YOU_HEAR_OPTIONS = [
  'Referral',
  'Word of Mouth',
  'Social Media',
  'Google',
  'Online Ads',
  'Other',
];

export const UK_COUNTRIES = [
  'England',
  'Ireland',
  'Northern Ireland',
  'Scotland',
  'Wales',
];

export const UK_COUNTRY_OPTIONS = UK_COUNTRIES.map((country) => ({
  value: country,
  label: country,
}));

export const UK_RATE_TYPE_OPTIONS = {
  'pact/faa': 'PACT/FAA',
  'pact/equity': 'PACT/Equity',
  'bbc/equity': 'BBC/Equity',
  commercial: 'Commercial',
  'non-union': 'Non-union',
  unscripted: 'Unscripted',
  other: 'Other',
};
export const RIGHT_TO_WORK_INFO = {
  firstBullet:
    'We are legally required to obtain proof of your right to work in the UK before you can start work, we therefore need a copy of your passport (or other right to work documentation) on file.',
  secondBullet:
    'Where requested to upload a photo of your documents, all images must be clear and legible.',
};
